<template>
  <div class="c-results__page" v-if="isActive">
    <p class="c-results__summary">
      You searched for "{{ searchTerm }}", we have found
      {{ totalResults }} results.
    </p>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "SearchPage",
  props: {
    isActive: {
      type: Boolean,
    },
    searchTerm: {
      type: String,
    },
    totalResults: {
      type: Number,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/components/consumer/results/SearchPage.vue